import {
  AddSquare,
  ArchiveBook,
  CalendarCircle,
  Clock,
  CloseCircle,
  DocumentDownload,
  DollarCircle,
  Edit,
  Gpgroup,
  Gpticket,
  HeartAdd,
  LikeTag,
  Logout,
  Lovely,
  MinusCirlce,
  MouseCircle,
  ReceiptItem,
  Setting2,
  Share,
  Sms,
  TableDocument,
  Teacher,
  TickCircle,
  Trash,
} from 'givepulse-iconsax-react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  grey: {
    width: '100%',
    backgroundColor: '#D4D4D4',
    color: '#222222',
  },

  blue: {
    width: '100%',
    backgroundColor: '#EBF7FF',
    color: '#235DB4',
  },

  green: {
    width: '100%',
    backgroundColor: '#D7F0D6',
    color: '#4F6B4F',
  },

  yellow: {
    width: '100%',
    backgroundColor: '#FAEBBE',
    color: '#5A4A1C',
  },

  organge: {
    width: '100%',
    backgroundColor: '#673C0F',
    color: '#FFC88E',
  },

  red: {
    width: '100%',
    backgroundColor: '#FADBDB',
    color: '#BE152A',
  },

  //for eventCard
  icon: {
    marginRight: 3,
    fontSize: 20,
  },
}));

//selects chip colors for the cards and list items ... set up this way so I dont have to copy and paste this switch in every componet that need it ...
export const chipColor = (status?: string) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { classes } = useStyles();
  const statusLower = status?.toLowerCase();

  switch (statusLower) {
    //BLUE CHIP (info)
    case 'submitted':
    case 'verified':
    case 'paid':
    case 'group member':
    case 'attended':
    case 'admin':
    case 'enrolled':
      return classes.blue;

    //Green Chip (success)
    case 'pledged':
    case 'active':
    case 'member':
    case 'registered':
    case 'reviewed':
    case 'approved':
    case 'complete':
    case 'completed':
    case 'free':
    case 'passed':
    case 'success':
      return classes.green;

    // YELLOW CHIP (waiting)
    case 'pending':
    case 'invoiced':
    case 'waiting approval':
    case 'expressed interest':
    case 'waitlist':
    case 'requested_information':
    case 'in_review':
    case 'started':
    case 'registrant':
    case 'volunteer':
    case 'progress':
    case 'warning':
      return classes.yellow;

    //RED CHIP (danger)
    case 'incomplete':
    case 'disputed':
    case 'declined':
    case 'cancelled':
    case 'denied':
    case 'unconfirmed':
    case 'no show':
    case 'not_admin':
    case 'never_attended':
    case 'wrong_numbers':
    case 'missing_data':
    case 'not yet started':
    case 'failure':
      return classes.red;

    // if not mapped, show grey
    default:
      return classes.grey;
  }
};
// selects the icons for the lists on the right side of the card under the chip also selects icons for cards also
export const iconDashSelect = (status: string) => {
  switch (status) {
    case 'manage':
      return <Setting2 size={24} />;
    case 'add impact':
      return <AddSquare size={24} />;
    case 'support group':
      return <HeartAdd size={24} />;
    case 'download':
    case 'download response':
    case 'export':
      return <DocumentDownload size={24} />;
    case 'verification logs':
      return <Clock size={24} />;
    case 'update':
    case 'update_registration':
      return <Edit size={24} />;
    case 'message':
      return <Sms size={24} />;
    case 'explore':
      return <MouseCircle size={24} />;
    case 'view registration':
      return <TableDocument size={24} />;
    case 'payment information':
      return <ReceiptItem size={24} />;
    case 'cancel registration':
    case 'cancel_registration':
    case 'cancel':
      return <MinusCirlce size={24} />;
    case 'view process log':
    case 'view submitted':
    case 'view reviews':
      return <TableDocument size={24} />;
    case 'impact_sharing_options':
      return <Share size={24} />;
    case 'leave_group':
      return <Logout size={24} />;
    case 'delete':
      return <Trash size={24} />;
    case 'activate':
      return <TickCircle size={24} />;
    case 'deactivate':
      return <CloseCircle size={24} />;

    default:
      return <AddSquare size={24} />;
  }
};

export const statusEventCardIcon = (status?: string) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { classes } = useStyles();
  switch (status) {
    case 'ticketed':
      return <Gpticket size="22" className={classes.icon} style={{ color: '#F2C94C' }} />;
    case 'nonvolunteer':
      return <CalendarCircle size="22" className={classes.icon} style={{ color: '#235DB4' }} />;
    case 'project':
      return <ArchiveBook size="22" className={classes.icon} style={{ color: '#235DB4' }} />;
    case 'pledge':
      return <LikeTag size="22" className={classes.icon} style={{ color: '#3E993D' }} />;
    case 'volunteer':
      return <Gpgroup size={22} style={{ minWidth: '22px', color: '#816B28' }} />;
    case 'internship':
      return <Teacher size="22" className={classes.icon} style={{ color: '#3E993D' }} />;
    case 'donation_drive':
      return <Lovely size="22" className={classes.icon} style={{ color: '#791E2A' }} />;
    case 'fundraiser':
      return <DollarCircle size="22" className={classes.icon} style={{ color: '#FF9F3A' }} />;
    default:
      return <ArchiveBook size="22" className={classes.icon} style={{ color: '#235DB4' }} />;
  }
};
